import React from 'react';
import type { SeoSlot } from '../../lib/seo/home-headings';

type Props = {
  slot: SeoSlot;
  className?: string;
  id?: string;
};

export default function SeoHeading({ slot, className, id }: Props) {
  if (!slot.enabled) return null;
  if (!slot.text.trim()) return null;

  const Tag = slot.tag as keyof JSX.IntrinsicElements;

  return <Tag id={id} className={className}>{slot.text}</Tag>;
}